import {
  CrudMode,
  DataDisplay,
  formatDate,
  formatSchoolYear,
  GeneralValidationErrors,
  Grid,
  pn,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { DatePicker, Input, Select } from "components";
import { StudentTest, StudentTestEditResource, StudentTestViewResource } from "generated/openApi";

import produce from "immer";
import "moment-timezone";

export const StudentTestPageBody = (props: {
  crudMode: CrudMode;
  test: StudentTest;
  setTest: (value: StudentTest) => void;
  viewResource: StudentTestViewResource;
  editResource: StudentTestEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];
  const generationValidationErrors = props.validationErrors[pn<StudentTest>("generalValidationErrors")];

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      {generationValidationErrors && (
        <Grid item xs={fullFieldBreakpoints}>
          <GeneralValidationErrors errors={generationValidationErrors} />
        </Grid>
      )}

      <Grid item xs={smallFieldBreakpoints}>
        {props.crudMode === "view" && (
          <DataDisplay label={properties.find((x) => x.propertyName === pn<StudentTest>("year"))?.displayName}>
            {formatSchoolYear(props.test.year)}
          </DataDisplay>
        )}
        {props.crudMode === "edit" && (
          <Select
            
            modelProperty={properties.find((x) => x.propertyName === pn<StudentTest>("year"))}
            errors={props.validationErrors[pn<StudentTest>("year")]}
            value={props.editResource.schoolYears?.find((x) => x.id === props.test.year)}
            options={props.editResource.schoolYears}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) =>
              props.setTest(
                produce(props.test, (draft) => {
                  draft.year = value?.id;
                })
              )
            }
          />
        )}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {props.crudMode === "view" && (
          <DataDisplay label={properties.find((x) => x.propertyName === pn<StudentTest>("testDate"))?.displayName}>
            {formatDate(props.test.testDate)}
          </DataDisplay>
        )}
        {props.crudMode === "edit" && (
          <DatePicker
            modelProperty={properties.find((x) => x.propertyName === pn<StudentTest>("testDate"))}
            errors={props.validationErrors[pn<StudentTest>("testDate")]}
            value={props.test.testDate}
            onChange={(value) =>
              props.setTest(
                produce(props.test, (draft) => {
                  draft.testDate = value;
                })
              )
            }
          />
        )}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {props.crudMode === "view" && (
          <DataDisplay label={properties.find((x) => x.propertyName === pn<StudentTest>("testTypeId"))?.displayName}>
            {props.test.testType?.name}
          </DataDisplay>
        )}
        {props.crudMode === "edit" && (
          <Select
            modelProperty={properties.find((x) => x.propertyName === pn<StudentTest>("testTypeId"))}
            errors={props.validationErrors[pn<StudentTest>("testTypeId")]}
            value={props.editResource.testTypes?.find((x) => x.id === props.test.testTypeId)}
            options={props.editResource.testTypes}
            getOptionLabel={(option) => option.name!}
            onChange={(e, value) =>
              props.setTest(
                produce(props.test, (draft) => {
                  draft.testTypeId = value?.id!;
                })
              )
            }
          />
        )}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {props.crudMode === "view" && (
          <DataDisplay label={properties.find((x) => x.propertyName === pn<StudentTest>("score"))?.displayName}>
            {props.test.score}
          </DataDisplay>
        )}
        {props.crudMode === "edit" && (
          <Input
            modelProperty={properties.find((x) => x.propertyName === pn<StudentTest>("score"))}
            errors={props.validationErrors[pn<StudentTest>("score")]}
            value={props.test.score}
            onChange={(e) =>
              props.setTest(
                produce(props.test, (draft) => {
                  draft.score = parseFloat(e.target.value);
                })
              )
            }
          />
        )}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {props.crudMode === "view" && (
          <DataDisplay label={properties.find((x) => x.propertyName === pn<StudentTest>("testLevelId"))?.displayName}>
            {props.test.testLevel?.name}
          </DataDisplay>
        )}
        {props.crudMode === "edit" && (
          <Select
            modelProperty={properties.find((x) => x.propertyName === pn<StudentTest>("testLevelId"))}
            errors={props.validationErrors[pn<StudentTest>("testLevelId")]}
            value={props.editResource.testLevels?.find((x) => x.id === props.test.testLevelId)}
            options={props.editResource.testLevels}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) =>
              props.setTest(
                produce(props.test, (draft) => {
                  draft.testLevelId = value?.id!;
                })
              )
            }
          />
        )}
      </Grid>
    </Grid>
  );
};
